<template>
  <div>
    <div class="search">
      <w-search-field @search="filterTree"/>
    </div>
    <article class="category-item">
      <el-scrollbar class="tree-wrapper">
        <el-tree class="report-tree tree-editor" :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" default-expand-all
          :expand-on-click-node="false" highlight-current @node-click="clickNode" :filter-node-method="filterNode" :render-content="renderContent">
        </el-tree>
      </el-scrollbar>
    </article>
    <w-add-report-popup ref="addReportPopup" :popup-params="popupParams" @load-tree-data="loadData"></w-add-report-popup>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import RouterTree from '@/mixins/router/tree';
import TreeFilter from '@/mixins/tree/filter';
import WSearchField from '@/components/form/SearchField';
import { defaultProps, treeType } from '@/constants/tree';
import { menuDefine } from '@/constants/menu';
import { routePath } from '@/utils/router';
import reportApi from '@/api/report/report';
import WAddReportPopup from '../popup/AddReportPopup';

export default {
  name: 'WReportTree',
  components: {
    WAddReportPopup,
    WSearchField,
  },
  mixins: [RouterTree, TreeFilter],
  data() {
    return {
      treeType: treeType.REPORT,
      treeData: null,
      defaultProps,
      popupParams: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 보고서 트리 데이터 로드
     * @author kimjy
     */
    loadData() {
      reportApi.getReportTreeData().then((response) => {
        if (response.data.success) {
          this.treeData = response.data.data;
        }
      });
    },
    getDefaultRouteTreeKey() {
      return isEmpty(this.treeData) || isEmpty(this.treeData[0]) ? null : this.treeData[0].treeKey;
    },
    /**
     * 트리 노드 클릭 시 화면 변경
     * @author kimjy
     * @param  {Object} nodeData 클릭된 노드
     */
    clickNode(nodeData) {
      this.routeByTreeKey(this.concatTreeTypeAndTreeKey(nodeData[this.defaultProps.treeKey]));
    },
    /**
     * 보고서 템플릿 레벨의 경우 '+' (추가) 버튼 필요
     * @author kimjy
     */
    renderContent(h, { data }) {
      if (!data.leaf) {
        return (
          <span class="el-tree-node__label">
            <span class="tree-node-edit-icon content-margin-r" on-click={ (event) => this.addReport(data, event) }>
              <i class="fas fa-plus-circle"></i>
            </span>
            <span>{data.label}</span>
          </span>);
      }

      return (
        <span class="el-tree-node__label">
          <span>{data.label}</span>
        </span>);
    },
    /**
     * 보고서 추가 팝업
     * @author kimjy
     * @param  {Object} data  클릭된 노드
     */
    addReport(data, event) {
      this.popupParams = data;
      this.$refs.addReportPopup.open();
      event.stopPropagation();
    },
  },
};
</script>

<style lang="scss">
.report-tree .el-tree-node__expand-icon.is-leaf {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/report/components/ReportTree.vue